// extracted by mini-css-extract-plugin
module.exports = {"white-full":"#f2f2f2","container":"projects_container__18RI9"};